import { Box, Card, CardContent, Skeleton, Typography } from "@mui/material";
import MoedaText from "../../util/ui/inputs/moedaText";
import { Moment } from "moment";

type Props = {
  titulo: string;
  data?: Moment;
  comuns?: number;
  daytrade?: number;
  fii?: number;
  total?: number;
  colorir?: boolean;
};

export default function Resumo({
  titulo,
  data,
  comuns,
  daytrade,
  fii,
  total,
  colorir = false,
}: Props) {
  // Resultado positivo em `positive`, negativo em `destructive` — nunca
  // verde/vermelho puro (DESIGN.md → Tabelas).
  const getCor = (numero?: number) => {
    if (!colorir || !numero || numero === 0) return "text.primary";
    if (numero < 0) return "error.main";
    if (numero > 0) return "success.main";
  };

  return (
    <Card>
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography
            variant="labelMono"
            color="text.secondary"
            sx={{ display: "block", mb: 1.5 }}
          >
            {titulo}
          </Typography>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="body2" color="text.secondary">
              em
            </Typography>
            <Typography
              variant="dataMono"
              color="text.primary"
              sx={{ fontWeight: 500 }}
            >
              {data !== undefined ? (
                data.format("DD/MM/YYYY")
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="body2" color="text.secondary">
              Comuns
            </Typography>
            <Typography
              variant="dataMono"
              color={getCor(comuns)}
              sx={{ fontWeight: 500 }}
            >
              {comuns !== undefined ? (
                <MoedaText value={comuns} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="body2" color="text.secondary">
              Daytrade
            </Typography>
            <Typography
              variant="dataMono"
              color={getCor(daytrade)}
              sx={{ fontWeight: 500 }}
            >
              {daytrade !== undefined ? (
                <MoedaText value={daytrade} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
          >
            <Typography variant="body2" color="text.secondary">
              FII/Fiagro
            </Typography>
            <Typography
              variant="dataMono"
              color={getCor(fii)}
              sx={{ fontWeight: 500 }}
            >
              {fii !== undefined ? (
                <MoedaText value={fii} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
          </Box>
          {/* Total separado por hairline, como a linha de total de uma tabela. */}
          <Box
            display="flex"
            flexDirection="row"
            alignItems="baseline"
            justifyContent="space-between"
            width="100%"
            sx={{ borderTop: 1, borderColor: "divider", pt: 1.5, mt: 1.5 }}
          >
            <Typography variant="labelMono" color="text.secondary">
              Total
            </Typography>
            <Typography
              color={getCor(total)}
              sx={{
                fontVariantNumeric: "tabular-nums",
                fontSize: 22,
                fontWeight: 600,
                letterSpacing: "-0.02em",
              }}
            >
              {total !== undefined ? (
                <MoedaText value={total} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
